import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModulesComponent } from '../../../service/modules/modules.component';
import { ServerService } from '../../../service/server/server.service';
import { MessageService } from '../../../service/message/message.service';

@Component({
  selector: 'app-repairman-invoice-filter',
  templateUrl: './repairman-invoice-filter.component.html',
  styleUrls: ['./repairman-invoice-filter.component.scss']
})
export class RepairmanInvoiceFilterComponent implements OnInit, OnDestroy {
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public loading: boolean = false;
  public search_array: any = [];
  public subscription: Subscription | any;
  public form1_group: FormGroup | any;
  public server!: any;
  public type_task!: number;
  public user_id!: number;
  public id!: number;
  public i!: number;
  public code!: number;
  public creator!: number;

  constructor(
    public serverService: ServerService,
    public router: Router,
    public matSnackBar: MatSnackBar,
    public messageService: MessageService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any,
    public matDialogRef: MatDialogRef<RepairmanInvoiceFilterComponent>) {
    this.server = this.serverService.get_server();
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    if (dialog_data) {
      this.create_form1();
      this.code = dialog_data.code;
      this.type_task = dialog_data.type_task;
      this.i = dialog_data.i;
      if (this.type_task == 1) {
      }
      if (this.type_task == 2) {
        this.check_access(4);
      }
      if (this.type_task == 3) {
        this.creator = dialog_data.creator;
        this.form1_group.patchValue({
          brand: dialog_data.search_array.brand,
          brand_title: dialog_data.search_array.brand_title,
          model: dialog_data.search_array.model,
          model_title: dialog_data.search_array.model_title,
          customer: dialog_data.search_array.customer,
          customer_title: dialog_data.search_array.customer_title,
          date1: dialog_data.search_array.date1,
          date2: dialog_data.search_array.date2,
          id2: dialog_data.search_array.id2,
        })
      }
    }
  }//end consructor
  search() {
    this.matDialogRef.close({
      brand: this.form1_group.value.brand,
      brand_title: this.form1_group.value.brand_title,
      model: this.form1_group.value.model,
      model_title: this.form1_group.value.model_title,
      customer: this.form1_group.value.customer,
      customer_title: this.form1_group.value.customer_title,
      date1: this.form1_group.value.date1,
      date2: this.form1_group.value.date2,
      id2: this.form1_group.value.id2,
    })
  }

  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
  }
  create_form1() {
    this.form1_group = new FormGroup({
      'title': new FormControl(null),
      'brand_title': new FormControl(null),
      'brand': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'model_title': new FormControl(null),
      'model': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'customer_title': new FormControl(null),
      'customer': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'date1': new FormControl(null),
      'date2': new FormControl(null),
      'id2': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
    });
  }
  check_access(type_task: any): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid && (this.type_task == 1 || this.type_task == 2)) {
      return false;
    }
    this.loading = true;
    var obj = {
      'address': 6,
      'type': 'user',
      'user_id': this.user_id,
      'id': this.code,
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
          }
          else {
            this.creator = res['creator'];
            this.loading = false;
            if (type_task == 1) { }
            if (type_task == 2) { }
            if (type_task == 3) { this.search(); }
            if (type_task == 4) { }
          }
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }
  load_services(id: number) {
    var code_id;
    if (id == 164) {
      code_id = 7276;
    }
    if (id == 163) {
      code_id = 7277;
    }

    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: {
        id: id, code_id: code_id, creator: this.creator, user_id: this.user_id, obj: {
          brand: this.form1_group.value.brand
        }
      }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          if (id == 161) {
            this.form1_group.patchValue({
              'customer': res.id,
              'customer_title': res.title
            })
          }
          if (id == 164) {
            this.form1_group.patchValue({
              'brand': res.id,
              'brand_title': res.title,
              'model': null,
              'model_title': null
            })
          }
          if (id == 163) {
            this.form1_group.patchValue({
              'model': res.id,
              'model_title': res.title
            })
          }
        }
      }
    )
  }
  reset_input(id: number) {
    if (id == 161) {
      this.form1_group.patchValue({
        'customer': null,
        'customer_title': null
      })
    }
    if (id == 164) {
      this.form1_group.patchValue({
        'brand': null,
        'brand_title': null,
        'model': null,
        'model_title': null
      })
    }
    if (id == 163) {
      this.form1_group.patchValue({
        'model_title': null,
        'model': null
      })
    }
  }
  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  required() {
    if (this.type_task == 1 || this.type_task == 2) {
      return true;
    }
    else {
      return false;
    }
  }
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 5000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
